import errors from './errors';
import general from './general';

export default {
  errors,
  general
};
